var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end" },
              [
                _c(
                  "b-button",
                  { attrs: { variant: "primary", to: "/journalentry/add" } },
                  [
                    _c("feather-icon", { attrs: { icon: "PlusIcon" } }),
                    _vm._v(" Add New "),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm.loading
            ? _c(
                "b-col",
                { staticClass: "text-center my-2", attrs: { cols: "12" } },
                [
                  _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning", block: "" },
                  }),
                ],
                1
              )
            : _vm._e(),
          !_vm.loading
            ? [
                _c(
                  "b-col",
                  {
                    staticClass: "my-1",
                    attrs: { cols: "12", md: "2", sm: "2" },
                  },
                  [
                    _c(
                      "b-form-group",
                      { staticClass: "mb-0" },
                      [
                        _c(
                          "label",
                          { staticClass: "d-inline-block text-sm-left mr-50" },
                          [_vm._v("Per page")]
                        ),
                        _c("b-form-select", {
                          attrs: {
                            id: "perPageSelect",
                            size: "sm",
                            options: _vm.pageOptions,
                          },
                          model: {
                            value: _vm.perPage,
                            callback: function ($$v) {
                              _vm.perPage = $$v
                            },
                            expression: "perPage",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  {
                    staticClass: "d-flex justify-content-end mb-2",
                    staticStyle: { position: "relative", "z-index": "1" },
                    attrs: { cols: "12" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-danger" },
                        on: { click: _vm.clearFilters },
                      },
                      [_vm._v(" Clear Filters ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("b-table", {
                      attrs: {
                        responsive: "",
                        "current-page": _vm.currentPage,
                        "per-page": _vm.perPage,
                        items: _vm.filteredJournalEntries,
                        "sort-by": _vm.sortBy,
                        "sort-desc": _vm.sortDesc,
                        fields: _vm.fields,
                        striped: "",
                      },
                      on: {
                        "update:sortBy": function ($event) {
                          _vm.sortBy = $event
                        },
                        "update:sort-by": function ($event) {
                          _vm.sortBy = $event
                        },
                        "update:sortDesc": function ($event) {
                          _vm.sortDesc = $event
                        },
                        "update:sort-desc": function ($event) {
                          _vm.sortDesc = $event
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "head(ref)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v(_vm._s(scope.label))]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Reference",
                                        size: "sm",
                                      },
                                      model: {
                                        value: _vm.filters.refID,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "refID", $$v)
                                        },
                                        expression: "filters.refID",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(date)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v(_vm._s(scope.label))]),
                                    _c("DatePicker", {
                                      staticClass: "small-datepicker",
                                      attrs: {
                                        range: "",
                                        placeholder: "Select Date Range",
                                        size: "sm",
                                      },
                                      model: {
                                        value: _vm.filters.dateRange,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "dateRange",
                                            $$v
                                          )
                                        },
                                        expression: "filters.dateRange",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(debit)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v(_vm._s(scope.label))]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Debit",
                                        size: "sm",
                                        type: "number",
                                      },
                                      model: {
                                        value: _vm.filters.debit,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "debit", $$v)
                                        },
                                        expression: "filters.debit",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(credit)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("span", [_vm._v(_vm._s(scope.label))]),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder: "Search Credit",
                                        size: "sm",
                                        type: "number",
                                      },
                                      model: {
                                        value: _vm.filters.credit,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "credit", $$v)
                                        },
                                        expression: "filters.credit",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(ref)",
                            fn: function (row) {
                              return [
                                _c("span", [_vm._v(_vm._s(row.item.refID))]),
                              ]
                            },
                          },
                          {
                            key: "cell(date)",
                            fn: function (row) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.formatDate(row.item.date))),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "cell(debit)",
                            fn: function (row) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(row.item.totalDebit)),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "cell(credit)",
                            fn: function (row) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(row.item.totalCredit)),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (row) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "text-decoration-none",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "text-body align-middle mr-25",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          to: _vm.viewJournalEntry(row.item.id),
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          staticClass: "mr-50",
                                          attrs: { icon: "EyeIcon" },
                                        }),
                                        _c("span", [_vm._v("View")]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          to: {
                                            path:
                                              "/journalentry/edit/" +
                                              row.item.id,
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          staticClass: "mr-50",
                                          attrs: { icon: "Edit2Icon" },
                                        }),
                                        _c("span", [_vm._v("Edit")]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteEntry(row.item.id)
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          staticClass: "mr-50",
                                          attrs: { icon: "TrashIcon" },
                                        }),
                                        _c("span", [_vm._v("Delete")]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        794147437
                      ),
                    }),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("b-pagination", {
                      staticClass: "my-0",
                      attrs: {
                        "total-rows": _vm.totalRows,
                        "per-page": _vm.perPage,
                        align: "center",
                        size: "sm",
                      },
                      model: {
                        value: _vm.currentPage,
                        callback: function ($$v) {
                          _vm.currentPage = $$v
                        },
                        expression: "currentPage",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }